<template>
    <PublicProfileLayout>
        <!-- Hero / Banner Section -->
        <VideoSection />

        <!-- Why ILearn’d Tutors Section -->
        <WhyIlearndSection />

        <!-- How it works  -->
        <HowitWorksSection />

        <!-- Subjects We Have Section -->
        <SubjectsListSection />

        <!-- Join as an Institute Section -->
        <CommunitySection title="Join as an institute"
            description="Partner with ILearn’d Tutors to expand your institution’s reach and connect with motivated learners nationwide."
            label="Apply as an Institution" :imageUrl="IntituteImageUrl" />

        <!-- For Educators Section -->
        <SkillsSection />

        <!-- ready to start teaching -->
        <CommunitySection title="Ready to Start Teaching?"
            description="Join hundreds of qualified tutors who are already earning a living by sharing their knowledge."
            label="Apply as a Tutor" :imageUrl="teachingImageUrl" />


        <!-- Students Testimonials Section -->
        <TestimonialSection :testimonials="testimonials" title="What Our Students Say"
            badgeTitle="Students Testimonials" />

        <!-- Contact Section -->
        <QuestionSection />

    </PublicProfileLayout>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { mixpanelService } from '@/services/mixpanel';

import PublicProfileLayout from "@/layout/PublicProfileLayout.vue";
import CommunitySection from "@/components/landingPage/commonSections/communitySection.vue"
import WhyIlearndSection from "@/components/landingPage/homePage/whyIlearndSection.vue"
import HowitWorksSection from "@/components/landingPage/homePage/howitWorksSection.vue"
import SubjectsListSection from "@/components/landingPage/homePage/subjectsListSection.vue"
import SkillsSection from "@/components/landingPage/homePage/skillsSection.vue"
import TestimonialSection from "@/components/landingPage/commonSections/testimonialSection.vue"
import QuestionSection from "@/components/landingPage/homePage/questionSection.vue"
import VideoSection from "@/components/landingPage/homePage/videoSection.vue"


const IntituteImageUrl = "public/institute.jpg"
const teachingImageUrl = "public/start-teaching.jpg"
const testimonials = ref([
    {
        name: "Kasun Rajapaksa",
        role: "A/L Student",
        location: "ICT, Kandy",
        avatar: "",
        testimonial: "The ICT tutor helped me with both theoretical concepts and practical programming. The one-on-one attention really made a difference. I'm now confident about my A/L ICT exam."
    },
    {
        name: "Kasun Rajapaksa",
        role: "A/L Student",
        location: "ICT, Kandy",
        avatar: "",
        testimonial: "The ICT tutor helped me with both theoretical concepts and practical programming. The one-on-one attention really made a difference. I'm now confident about my A/L ICT exam."
    },
    {
        name: "Kasun Rajapaksa",
        role: "A/L Student",
        location: "ICT, Kandy",
        avatar: "",
        testimonial: "The ICT tutor helped me with both theoretical concepts and practical programming. The one-on-one attention really made a difference. I'm now confident about my A/L ICT exam."
    }
]);

// Track home page visit
onMounted(() => {
  mixpanelService.track('Page Viewed', {
    page_name: 'Home Page',
    page_path: '/',
    timestamp: new Date().getTime()
  });
});
</script>

<style scoped>
/* how it works */
.how-section img {
    max-width: 100%;
    height: auto;
    object-fit: cover;
}



/* Align with other sections */
@media (min-width: 768px) {
    .subjects-section>div {
        padding-left: 3rem;
        padding-right: 3rem;
    }
}

/* Responsive tweaks */
@media (max-width: 767px) {
    .subject-card {
        text-align: center;
    }
}


/* Instittute section */
.institute-section {
    background-color: #ffffff;
}

.card-container {
    position: relative;
    min-height: 260px;
    background-color: #000;
}

.community-badge {
    background-color: #F1F4FA;
    border-radius: 25px;
}

/* Button hover */
.p-button-success:hover {
    background-color: #00c58e !important;
    border-color: #00c58e !important;
}

/* Responsive alignment */
@media (max-width: 768px) {
    .card-container {
        min-height: 220px;
    }
}



/* Mobile Responsive */
@media screen and (max-width: 960px) {
    .customized-timeline .p-timeline-event {
        flex-direction: row !important;
    }

    .customized-timeline .p-timeline-event-opposite {
        flex: 0;
        padding: 0;
    }

    .customized-timeline .p-timeline-event-content {
        text-align: left;
        padding: 0 0 0 1rem;
    }

    .customized-timeline .p-timeline-event-connector {
        width: 2px;
        margin: 0 1.5rem;
    }

    .step-visual img {
        height: 200px;
    }

    .step-content h3 {
        font-size: 1.5rem;
    }

    .step-content p {
        font-size: 1rem;
    }
}

@media (min-width: 768px) and (max-width: 1023px) {
    .step-visual img {
        height: 220px;
    }
}

@media (min-width: 1024px) {
    .step-visual img {
        height: 280px;
    }
}
</style>
